(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["batch-search"] && !Shopify.designMode) return;
  try {
    
(() => {
  const normalizeHandle = (value) => value
    .trim()
    .toLowerCase()
    .replace(/ß/g, 'ss')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

  document.querySelectorAll('[data-batch-lookup]').forEach((root) => {
    if (root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    const form = root.querySelector('[data-batch-form]');
    const input = root.querySelector('[data-batch-input]');
    const button = root.querySelector('[data-batch-submit]');
    const message = root.querySelector('[data-batch-message]');
    const basePath = (root.dataset.basePath || '/pages/charge/').replace(/\/+$/, '') + '/';

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      message.textContent = '';

      const handle = normalizeHandle(input.value);
      if (!handle) {
        message.textContent = 'Bitte gib deine Chargennummer ein.';
        input.focus();
        return;
      }

      const target = `${basePath}${encodeURIComponent(handle)}`;
      root.classList.add('is-loading');
      button.disabled = true;

      try {
        const response = await fetch(target, {
          method: 'GET',
          credentials: 'same-origin',
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        });

        if (!response.ok) throw new Error('not-found');

        window.location.assign(target);
      } catch (error) {
        message.textContent = 'Diese Chargennummer wurde nicht gefunden. Bitte prüfe die Eingabe.';
        root.classList.remove('is-loading');
        button.disabled = false;
        input.focus();
        input.select();
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-charge-story"] && !Shopify.designMode) return;
  try {
    
(() => {
  const pad = (n) => String(n).padStart(2, '0');

  document.querySelectorAll('[data-charge-story]').forEach((root) => {
    if (root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    const slides = [...root.querySelectorAll('[data-slide]')];
    const prev = root.querySelector('[data-prev]');
    const next = root.querySelector('[data-next]');
    const share = root.querySelector('[data-share]');
    const current = root.querySelector('[data-current]');
    const total = root.querySelector('[data-total]');
    const progress = root.querySelector('[data-progress]');
    const toast = root.querySelector('[data-toast]');
    let index = 0;
    let touchStartX = null;
    let touchStartY = null;
    let toastTimer;
    let resizeFrame = null;

    if (!slides.length) return;

    /*
      Mobile-Höhe robust gegen Shopify-Header, Announcement-Bar und
      dynamische Browserleisten berechnen. Entscheidend ist nicht eine
      angenommene Header-Höhe, sondern die echte Position der Story im Dokument.
    */
    const getOverlayHeaderBottom = () => {
      const selectors = [
        'sticky-header',
        '.header-wrapper',
        '.section-header',
        '.shopify-section-group-header-group',
        '[id*="shopify-section"][class*="header"]',
        'header'
      ];

      const elements = [...new Set(selectors.flatMap((selector) => [...document.querySelectorAll(selector)]))];
      let bottom = 0;

      elements.forEach((element) => {
        if (element === root || root.contains(element)) return;

        const style = getComputedStyle(element);
        if (style.display === 'none' || style.visibility === 'hidden') return;
        if (style.position !== 'fixed' && style.position !== 'sticky') return;

        const rect = element.getBoundingClientRect();
        if (rect.height <= 0 || rect.bottom <= 0) return;
        if (rect.top > 180) return;

        bottom = Math.max(bottom, rect.bottom);
      });

      return Math.max(0, bottom);
    };

    const syncMobileGeometry = () => {
      if (!window.matchMedia('(max-width: 820px)').matches) {
        root.style.removeProperty('--charge-story-height');
        root.style.removeProperty('--charge-chrome-space');
        return;
      }

      const viewportHeight = window.visualViewport?.height || window.innerHeight;
      const rect = root.getBoundingClientRect();
      const documentTop = rect.top + window.scrollY;
      const overlayHeaderBottom = getOverlayHeaderBottom();

      // documentTop erfasst Header + Announcement-Bar, wenn sie im normalen Flow liegen.
      // Bei einem überlagernden fixed/sticky Header greift overlayHeaderBottom.
      const flowTop = Math.max(0, Math.min(documentTop, viewportHeight * 0.34));
      const topOffset = Math.max(flowTop, overlayHeaderBottom);
      const storyHeight = Math.max(0, viewportHeight - topOffset);

      root.style.setProperty('--charge-story-height', `${Math.round(storyHeight)}px`);

      // Platz für die tatsächlich gerenderte Navigation reservieren.
      const chrome = root.querySelector('.charge-story__chrome');
      if (chrome) {
        const chromeHeight = chrome.getBoundingClientRect().height;
        root.style.setProperty('--charge-chrome-space', `${Math.ceil(chromeHeight + 26)}px`);
      }
    };

    const requestGeometrySync = () => {
      cancelAnimationFrame(resizeFrame);
      resizeFrame = requestAnimationFrame(syncMobileGeometry);
    };

    total.textContent = pad(slides.length);
    syncMobileGeometry();
    requestAnimationFrame(syncMobileGeometry);
    setTimeout(syncMobileGeometry, 250);

    window.addEventListener('resize', requestGeometrySync, { passive: true });
    window.addEventListener('orientationchange', requestGeometrySync, { passive: true });
    window.visualViewport?.addEventListener('resize', requestGeometrySync, { passive: true });

    const showToast = (text) => {
      clearTimeout(toastTimer);
      toast.textContent = text;
      toast.classList.add('is-visible');
      toastTimer = setTimeout(() => toast.classList.remove('is-visible'), 2200);
    };

    const goTo = (nextIndex, updateHash = true) => {
      index = (nextIndex + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === index);
        slide.inert = i !== index;
        slide.setAttribute('aria-hidden', String(i !== index));
      });
      current.textContent = pad(index + 1);
      progress.style.transform = `scaleX(${(index + 1) / slides.length})`;
      requestAnimationFrame(syncMobileGeometry);

      if (updateHash) {
        history.replaceState(null, '', `${location.pathname}${location.search}#slide-${index + 1}`);
      }
    };


    const config = JSON.parse(root.querySelector('[data-share-config]').textContent);
    const dialog = root.querySelector('[data-charge-share]');
    const preview = dialog.querySelector('[data-share-preview]');
    const canvas = dialog.querySelector('[data-share-canvas]');
    const toggleMotion = dialog.querySelector('[data-share-motion]');
    const stage = dialog.querySelector('[data-share-stage]');
    const placeholder = dialog.querySelector('[data-share-placeholder]');
    const send = dialog.querySelector('[data-share-send]');
    const download = dialog.querySelector('[data-share-download]');
    const createVideo = dialog.querySelector('[data-share-video-create]');
    const createVideoLabel = dialog.querySelector('[data-share-video-label]');
    const videoActions = dialog.querySelector('[data-share-video-actions]');
    const sendVideo = dialog.querySelector('[data-share-video-send]');
    const downloadVideo = dialog.querySelector('[data-share-video-download]');
    const unsupported = dialog.querySelector('[data-share-video-unsupported]');
    const status = dialog.querySelector('[data-share-status]');
    const messages = config.messages;
    const artworkCache = new Map();
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let artworkLoad;
    let artworkUrl;
    let videoUrl;
    let shareFile;
    let videoFile;
    let shareLink;
    let animation;
    let exportController;
    let activeArtwork;
    let motionPaused = reducedMotion.matches;
    let generation = 0;
    let opener;

    const loadArtwork = () => {
      if (window.ChargeStoryArtwork) return Promise.resolve(window.ChargeStoryArtwork);
      if (artworkLoad) return artworkLoad;
      artworkLoad = new Promise((resolve, reject) => {
        const script = document.createElement('script');
        const failed = () => {
          clearTimeout(timeout);
          artworkLoad = null;
          script.remove();
          reject(new Error('Artwork unavailable'));
        };
        const timeout = setTimeout(failed, 15000);
        script.src = root.dataset.artworkSource;
        script.async = true;
        script.onload = () => {
          clearTimeout(timeout);
          if (window.ChargeStoryArtwork) resolve(window.ChargeStoryArtwork);
          else failed();
        };
        script.onerror = failed;
        document.head.append(script);
      });
      return artworkLoad;
    };

    const syncMotion = () => {
      toggleMotion.setAttribute('aria-pressed', String(motionPaused));
      toggleMotion.textContent = motionPaused ? messages.play_motion : messages.pause_motion;
      if (!animation) return;
      if (motionPaused || document.hidden || !dialog.open) animation.pause();
      else animation.resume();
    };

    const stopArtwork = () => {
      animation?.stop();
      animation = null;
      exportController?.abort();
      exportController = null;
      activeArtwork = null;
      if (artworkUrl) URL.revokeObjectURL(artworkUrl);
      if (videoUrl) URL.revokeObjectURL(videoUrl);
      artworkUrl = null;
      videoUrl = null;
      shareFile = null;
      videoFile = null;
    };

    const shareCurrent = async () => {
      opener = document.activeElement;
      stopArtwork();
      const slide = slides[index];
      const variant = slide.dataset.shareVariant || 'intro';
      const publicUrl = new URL(location.pathname, location.origin);
      publicUrl.hash = `slide-${index + 1}`;
      shareLink = publicUrl.href;
      const photo = slide.dataset.shareImageMobile || slide.dataset.shareImage || '';
      const data = { ...config, photo, url: publicUrl.href };
      const key = `${variant}|${photo}|${publicUrl.href}`;
      const currentGeneration = ++generation;
      motionPaused = reducedMotion.matches;
      send.disabled = true;
      createVideo.disabled = true;
      createVideo.hidden = false;
      createVideoLabel.textContent = messages.create_video;
      videoActions.hidden = true;
      unsupported.hidden = true;
      toggleMotion.hidden = true;
      download.removeAttribute('href');
      download.setAttribute('aria-disabled', 'true');
      downloadVideo.removeAttribute('href');
      stage.setAttribute('aria-busy', 'true');
      placeholder.hidden = false;
      preview.hidden = true;
      canvas.hidden = true;
      status.textContent = messages.loading;
      dialog.showModal();
      dialog.querySelector('.charge-share__layout').scrollTop = 0;
      syncMotion();
      try {
        const engine = await loadArtwork();
        let artwork = artworkCache.get(key);
        if (!artwork) {
          const scene = await engine.prepare(data, variant);
          const blob = await scene.poster();
          artwork = { scene, blob };
          if (artworkCache.size >= 5) artworkCache.delete(artworkCache.keys().next().value);
          artworkCache.set(key, artwork);
        }
        if (currentGeneration !== generation || !dialog.open) return;
        activeArtwork = { ...artwork, data, variant, engine };
        artworkUrl = URL.createObjectURL(artwork.blob);
        const filename = `Meine-Manuka-Charge-${String(config.batch).replace(/[^a-z0-9_-]/gi, '')}-${variant}.png`;
        shareFile = new File([artwork.blob], filename, { type: 'image/png' });
        preview.src = artworkUrl;
        preview.hidden = false;
        placeholder.hidden = true;
        stage.setAttribute('aria-busy', 'false');
        download.href = artworkUrl;
        download.download = filename;
        download.setAttribute('aria-disabled', 'false');
        send.disabled = false;
        const videoSupported = typeof MediaRecorder !== 'undefined' && typeof canvas.captureStream === 'function' && engine.supportedVideoTypes().length > 0;
        createVideo.hidden = !videoSupported;
        createVideo.disabled = !videoSupported;
        unsupported.hidden = videoSupported;
        status.textContent = messages.ready;
        try {
          const controller = await engine.animateCanvas(canvas, data, variant, { scene: artwork.scene, paused: motionPaused || document.hidden });
          if (currentGeneration !== generation || !dialog.open) { controller.stop(); return; }
          animation = controller;
          canvas.hidden = false;
          preview.hidden = true;
          toggleMotion.hidden = false;
          syncMotion();
        } catch (error) {
          canvas.hidden = true;
          preview.hidden = false;
        }
      } catch (error) {
        if (currentGeneration !== generation) return;
        stage.setAttribute('aria-busy', 'false');
        status.textContent = messages.error;
      }
    };

    const sharePreparedFile = async (file, fallback, video = false) => {
      if (!file) return;
      let canShare = false;
      try { canShare = Boolean(navigator.share && navigator.canShare?.({ files: [file] })); } catch (error) { canShare = false; }
      if (canShare) {
        try { await navigator.share({ files: [file], title: `${config.labels.my_honey}${config.labels.my_honey.endsWith('-') ? '' : ' '}${config.labels.batch} ${config.batch}` }); }
        catch (error) { if (error.name !== 'AbortError') status.textContent = video ? messages.video_download_hint : messages.download_hint; }
      } else {
        fallback.click();
        status.textContent = video ? messages.video_saved : messages.saved;
      }
    };

    send.addEventListener('click', () => sharePreparedFile(shareFile, download));
    sendVideo.addEventListener('click', () => sharePreparedFile(videoFile, downloadVideo, true));
    download.addEventListener('click', (event) => {
      if (!shareFile) event.preventDefault();
    });
    downloadVideo.addEventListener('click', (event) => {
      if (!videoFile) event.preventDefault();
    });
    toggleMotion.addEventListener('click', () => {
      motionPaused = !motionPaused;
      syncMotion();
    });
    document.addEventListener('visibilitychange', syncMotion);
    reducedMotion.addEventListener('change', () => {
      if (reducedMotion.matches) { motionPaused = true; syncMotion(); }
    });

    createVideo.addEventListener('click', async () => {
      if (!activeArtwork || exportController) return;
      const currentGeneration = generation;
      const artwork = activeArtwork;
      const controller = new AbortController();
      exportController = controller;
      createVideo.disabled = true;
      animation?.pause();
      let lastProgress = -1;
      status.textContent = messages.video_preparing;
      try {
        const result = await artwork.engine.exportAnimation(artwork.data, artwork.variant, {
          scene: artwork.scene,
          signal: controller.signal,
          onProgress: (ratio) => {
            if (currentGeneration !== generation || !dialog.open) return;
            const progress = Math.min(100, Math.floor(ratio * 10) * 10);
            if (progress === lastProgress) return;
            lastProgress = progress;
            createVideoLabel.textContent = `${messages.video_preparing} ${progress}%`;
          }
        });
        if (currentGeneration !== generation || !dialog.open) return;
        const extension = result.extension.toLowerCase().replace(/[^a-z0-9]/g, '');
        const filename = `Meine-Manuka-Charge-${String(config.batch).replace(/[^a-z0-9_-]/gi, '')}-${artwork.variant}.${extension}`;
        videoUrl = URL.createObjectURL(result.blob);
        videoFile = new File([result.blob], filename, { type: result.mimeType });
        downloadVideo.href = videoUrl;
        downloadVideo.download = filename;
        downloadVideo.querySelector('span').textContent = `${messages.download_video} · ${extension.toUpperCase()}`;
        videoActions.hidden = false;
        createVideo.hidden = true;
        status.textContent = extension === 'mp4' ? messages.video_ready_mp4 : messages.video_ready_webm;
      } catch (error) {
        if (currentGeneration !== generation || error.name === 'AbortError') return;
        status.textContent = messages.video_error;
        createVideo.disabled = false;
      } finally {
        if (exportController === controller) exportController = null;
        if (currentGeneration === generation) {
          createVideoLabel.textContent = messages.create_video;
          syncMotion();
        }
      }
    });
    dialog.querySelector('[data-share-copy]').addEventListener('click', async () => {
      try { await navigator.clipboard.writeText(shareLink); status.textContent = messages.copied; }
      catch (error) { status.textContent = messages.copy_error; }
    });
    dialog.querySelector('[data-share-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (event) => {
      if (event.target !== dialog) return;
      const bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
    });
    dialog.addEventListener('close', () => {
      generation += 1;
      stopArtwork();
      opener?.focus({ preventScroll: true });
    });
    root.querySelectorAll('[data-share-open]').forEach(button => button.addEventListener('click', shareCurrent));

    prev.addEventListener('click', () => goTo(index - 1));
    next.addEventListener('click', () => goTo(index + 1));
    share.addEventListener('click', shareCurrent);

    root.addEventListener('keydown', (event) => {
      if (dialog.open) return;
      if (event.key === 'ArrowLeft') goTo(index - 1);
      if (event.key === 'ArrowRight') goTo(index + 1);
    });

    root.tabIndex = 0;

    root.addEventListener('touchstart', (event) => {
      if (dialog.open) return;
      const touch = event.changedTouches[0];
      touchStartX = touch.clientX;
      touchStartY = touch.clientY;
    }, { passive: true });

    root.addEventListener('touchend', (event) => {
      if (dialog.open || touchStartX === null || touchStartY === null) return;

      const touch = event.changedTouches[0];
      const distanceX = touch.clientX - touchStartX;
      const distanceY = touch.clientY - touchStartY;

      touchStartX = null;
      touchStartY = null;

      // Vertikales Scrollen in Text/PDF-Slides nicht als Slide-Wechsel werten.
      if (Math.abs(distanceY) > Math.abs(distanceX)) return;
      if (Math.abs(distanceX) < 44) return;

      goTo(distanceX < 0 ? index + 1 : index - 1);
    }, { passive: true });

    const hashMatch = location.hash.match(/^#slide-(\d+)$/);
    if (hashMatch) {
      const requested = Math.min(Math.max(Number(hashMatch[1]) - 1, 0), slides.length - 1);
      goTo(requested, false);
    } else {
      goTo(0, false);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-password-header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
